
import './input.css'

const SelectJim = (props) => {

  const { name, value, label, placeholder, classN, error, onChange, items } = props;
  const handleChange = (e) => {
    const { name, value } = e.target
    onChange(name, value)
  }

  return (
    <>
      <div className={`select-container ${classN}`}>

        <select
          name={name}
          value={value}
          placeholder={placeholder}
          label={label}
          className={error ? 'select-input errorfocus' : 'select-input'}
          onChange={handleChange}
        >

          {items && items.map((item) => (
            <option key={item} value={item} >
              {item}
            </option>
          ))}

        </select>


        <label className='error'>
          {error}
        </label>
      </div>
    </>
  )
}
export default SelectJim